// extracted by mini-css-extract-plugin
export default {"highlight":"highlightableText_highlight__5Rfz8","text":"highlightableText_text__z0TnQ","textSurveyAnswer":"highlightableText_textSurveyAnswer__KEzkC"};